module.exports = __webpack_public_path__ + "static/media/171.0528c141.jpg";